// Estimating module API client — contained mode.
//
// Wraps the HOST app's axios instance (@/lib/api), which already carries
// the Bearer session token, token self-heal, and 401 handling. Every
// module path is prefixed with /estimating so the whole subsystem lives
// under /api/estimating/* on the backend.

import hostApi from "@/lib/api";

export const ESTIMATING_API = "/api/estimating";
// Absolute base URL for direct-download links (CSV export etc.) — same
// convention as the source app's API export, but prefixed for the module.
export const API = `${process.env.REACT_APP_BACKEND_URL}/api/estimating`;

const PREFIX = "/estimating";

const wrap =
  (fn) =>
  (url, ...rest) =>
    fn.call(hostApi, `${PREFIX}${url}`, ...rest);

export const api = {
  get: wrap(hostApi.get),
  post: wrap(hostApi.post),
  put: wrap(hostApi.put),
  patch: wrap(hostApi.patch),
  delete: wrap(hostApi.delete),
  request: wrap(hostApi.request),
  defaults: hostApi.defaults,
};

export default api;
